import React from "react";

import './MainHeader.css';

const MainHeader = function (props) {



    return (

        < header className="main-header" style={props.style} >
            {props.children}
        </header >
    );


};

export default MainHeader;